import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpUnauthorizedInterceptor } from './http-unauthorized-interceptor';

@NgModule({
  imports: [CommonModule]
})
export class UzurvCrmHttpInterceptorsModule {
  static forRoot(): ModuleWithProviders<UzurvCrmHttpInterceptorsModule> {
    return {
      ngModule: UzurvCrmHttpInterceptorsModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpUnauthorizedInterceptor,
          multi: true
        }
      ]
    };
  }
}
